import "./style/main.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LiveSoon from "./pages/LiveSoon";
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LiveSoon />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
